import * as React from 'react'
import { Route, Routes, useParams } from 'react-router-dom'
import { driversRoutes } from './routes'
import { driversPath } from './index'
import {
  toRelativeRoute,
  wrapRoutesWithRouter,
} from '../shared/utils/routerPaths'
import { AppLayoutDahboardWithNav } from '../shared/layouts'
import { ErrorBoundary } from '../shared/components/ErrorBoundary'
import { ErrorFallback } from '../shared/components/ErrorFallback'
import { DriversProvider } from '../shared/context/drivers/DriversContext'
import { TaskProvider } from '../shared/context/TaskContext'
import { DriversLayout } from './DriverLayout'

const wrappedDriversRoutes = wrapRoutesWithRouter(driversRoutes)

const DriversModuleImpl: React.FC = () => {
  const { companyId } = useParams<{ companyId: string }>()

  return (
    <ErrorBoundary
      fallback={(e) => <ErrorFallback error={e.error} onRetry={e.reset} />}
    >
      <TaskProvider>
        <DriversProvider>
          <AppLayoutDahboardWithNav>
            <ErrorBoundary
              fallback={(e) => (
                <ErrorFallback error={e.error} onRetry={e.reset} />
              )}
            >
              <Routes>
                {wrappedDriversRoutes.map((route) => (
                  <Route
                    key={route.path}
                    path={`${toRelativeRoute(route.path, driversPath)}/*`}
                    element={
                      <DriversLayout
                        companyId={companyId!}
                        viewControlBar={route.viewControlBar}
                        navigation={route.navigation}
                        heightScreen={route.heightScreen}
                        fullScreen={route.fullScreen}
                        hideSidePanel={route.hideSidePanel}
                      >
                        <route.Component />
                      </DriversLayout>
                    }
                  />
                ))}

                {/* fallback */}
                <Route
                  path="*"
                  element={
                    <DriversLayout companyId={companyId!}>
                      <div>Select</div>
                    </DriversLayout>
                  }
                />
              </Routes>
            </ErrorBoundary>
          </AppLayoutDahboardWithNav>
        </DriversProvider>
      </TaskProvider>
    </ErrorBoundary>
  )
}

export const DriversModule = DriversModuleImpl
